export function rangexy(start: number, end: number): number[] {
  return Array.from(
    { length: end - start },
    (_: number, k: number) => k + start
  );
}
